import React, { createRef } from "react";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-coverflow";
import Navigation from "../../components/Navigation";
import Footer from "../../components/footer";
import Swipercarousel from "../../components/swipercarousel";
import Divisionservice from "../../components/divisionandservice";
import Whychooseus from "../../components/whychooseus";
import Socials from "../../components/socialbottom";
import Featuredjob from "../../components/featuredjobcards";
import LandingPagePresenter from "./LandingPagePresenter";
import { signInUseCase, signOutUseCase } from "../../usecases/user";
import PortalSearch from "../../components/PortalSearch";

class LandingPage extends BasePage {
  constructor(props) {
    super(props);
    this.jobCardsRef = createRef();
    this.presenter = new LandingPagePresenter(
      this,
      signInUseCase(),
      signOutUseCase()
    );
  }

  scrollToJobCards = () => {
    if (this.jobCardsRef.current) {
      window.scrollTo({
        top: this.jobCardsRef.current.offsetTop - 100, // Adjust offset so the title is visible
        behavior: "smooth",
      });
    }
  };

  logout() {
    this.presenter.onClickSignOut();
  }

  // Handle search input and redirect to JobPortalListPage
  handleSearchInput = (searchValue) => {
    // Navigate to JobPortalListPage with search query as URL parameter
    this.navigateTo(`/jobportal?search=${encodeURIComponent(searchValue)}`);
  };

  render() {
    return (
      <>
        <section
          className="position-relative d-flex flex-column"
          style={{ height: "100vh", width: "100vw", overflow: "hidden" }}
        >
          <Navigation logout={this.logout.bind(this)} />

          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ paddingTop: "110px" }}
          >
            <h1 className="fw-bold text-center" style={{ color: "#303030" }}>
              Our Job is to Make Your <br /> Job{" "}
              <i style={{ color: "#D18237" }}>EASIER</i>
            </h1>

            <div className="mt-1 position-relative col-lg-4 col-sm-8">
              <PortalSearch
                placeholder={"Start your Job Search"}
                onInput={this.handleSearchInput}
                redirectOnInput={true}
              />
            </div>
          </div>

          {/* Image Section - No Wild Resizing */}
          <div className="d-flex flex-column align-items-center flex-grow-1">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ flexGrow: 1, width: "100%", marginTop: "-80px" }}
            >
              <img
                src="/hsgp.png"
                style={{
                  maxWidth: "100vw", // Limits width
                  maxHeight: "70vh", // Limits height
                  objectFit: "cover", // Prevents distortion
                  zIndex: "-2",
                }}
                alt="Landing Visual"
              />
            </div>
          </div>

          <div
            className="d-flex flex-column align-items-center w-100"
            style={{ marginTop: "auto" }}
          >
            {/* Jumping Circle with Arrow */}
            <div
              className="circle-container position-relative"
              style={{ top: "-120px" }}
            >
              <div
                className="jumping-circle"
                onClick={this.scrollToJobCards}
                style={{ cursor: "pointer" }}
              >
                <i className="bi bi-arrow-down"></i>
              </div>
            </div>

            <Swipercarousel />
          </div>
        </section>

        {/* <section id="jobCards" ref={this.jobCardsRef}>
          <div
            className="d-flex align-items-start flex-column"
            style={{ margin: "0 15%", marginTop: "3%" }}
          >
            <h2 className="mb-1 fw-bold" style={{ color: "#303030" }}>
              FEATURED{" "}
              <i style={{ color: "#D18237", fontWeight: "700" }}>JOBS</i>
            </h2>
            <p className="mb-4" style={{ fontSize: "1.1rem" }}>
              Explore featured jobs at <i>top-tier Hotels</i>
            </p>

            <Featuredjob />
          </div>
        </section> */}

        <section>
          <div
            className="d-flex align-items-center flex-column"
            style={{ margin: "0 15%", marginTop: "6%" }}
          >
            <h2 className="mb-1 fw-bold" style={{ color: "#303030" }}>
              DIVISIONS AND{" "}
              <i style={{ color: "#D18237", fontWeight: "700" }}>SERVICES</i>
            </h2>
            <p className="mb-4" style={{ fontSize: "1.1rem" }}>
              Your <b>Skills</b> matter here—unlock endless <b>opportunities</b>{" "}
              with us.
            </p>
          </div>

          <Divisionservice />
        </section>

        <section className="container" style={{ marginTop: "85px" }}>
          {/* Header and Logo aligned horizontally */}
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="fw-bold mb-2" style={{ color: "#303030" }}>
              WHY SHOULD YOU{" "}
              <span style={{ color: "#D18237" }}>
                <br />
                <i>
                  CHOOSE US<i style={{ color: "#303030" }}>?</i>
                </i>
              </span>
            </h1>
            <img
              className="me-4"
              src="cutnobg.png"
              alt="Logo"
              style={{ width: "100px", height: "70px" }}
            />
          </div>

          <Whychooseus />
        </section>

        <section>
          <Footer />
        </section>

        <Socials />
      </>
    );
  }
}

export default withRouter(LandingPage);
